import _environmentUserAgent from "../internals/environment-user-agent";
var exports = {};
var UA = _environmentUserAgent;
exports = /MSIE|Trident/.test(UA);
export default exports;